module.exports = __webpack_public_path__ + "static/img/暂无搜索内容.4a11aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无搜索内容.jpg
// module id = dyMP
// module chunks = 1